import { render, staticRenderFns } from "./VideoLibrary.vue?vue&type=template&id=af1eb726&"
import script from "./VideoLibrary.vue?vue&type=script&lang=js&"
export * from "./VideoLibrary.vue?vue&type=script&lang=js&"
import style0 from "./VideoLibrary.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports